import { AppConfig } from './AppConfig';

const baseUrl = 'https://pg-1142.pharmagarde.be';
const basePlannerUrl = 'http://pg-1142.pharmagarde.be:8080';

const config: AppConfig = {
  configName: 'pg-1142',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
};

export default config;
